module.exports = __webpack_public_path__ + "img/male_3.30934178.png";